import { useState, useEffect } from "react";
import RingLoader from "../../../components/Loaders/RingLoader";
import ledMode from "../../../consts/ledMode";
import SettingsButton from "../../../components/Buttons/SettingsButton/SettingsButton";
import { LedSvgSmall, MoonSvgSmall } from "../../../components/Icons/svgIcons";
import deviceService from "../../../services/device/deviceService";
import scpService from "../../../services/scp/scpService";

const LedSettings = ({ id }) => {
    const [modeLoading, setModeLoading] = useState(false);
    const [mode, setMode] = useState(false);

    useEffect(() => {
        initLedState()
    }, []);

    const initLedState = async () => {
        await getLedMode();
    }

    const getLedMode = async () => {
        try {
            setModeLoading(true);
            const led = await scpService.runWithBackOff(id, () => deviceService.getLedSettings(id));
            setMode(led);
        } catch (e) {
            console.error(e);
        }

        setModeLoading(false);
    };

    const setNewLedMode = async (mode) => {
        setModeLoading(true);
        try {
            await scpService.runWithBackOff(id, () => deviceService.setLedSettings(id, mode));
        } catch (e) {
            console.error(e);
        }

        await getLedMode();
    };

    return (
        <>
            <div className="text-m text-start">Led settings:</div>
            <div className="flex flex-row justify-center items-center w-ful">
                <div className="flex flex-row gap-4 justify-center items-center border rounded-md p-3">
                    <div>
                        {mode === ledMode.NIGHT ? <MoonSvgSmall /> : <LedSvgSmall />}
                    </div>
                    <div>{mode}</div>
                </div>
                {modeLoading ? (
                    <div className="flex grow-1 flex-row justify-center w-full">
                        <RingLoader color="black"></RingLoader>
                    </div>
                ) : (
                    <div className="flex grow-1 flex-row justify-center w-full gap-4">
                        <SettingsButton
                            onClick={() => setNewLedMode(ledMode.DAY)}
                            disabled={modeLoading || mode === ledMode.DAY}
                        >
                            <LedSvgSmall isSelected={mode === ledMode.DAY} />
                        </SettingsButton>
                        <SettingsButton
                            onClick={() => setNewLedMode(ledMode.NIGHT)}
                            disabled={modeLoading || mode === ledMode.NIGHT}
                        >
                            <MoonSvgSmall isSelected={mode === ledMode.NIGHT} />
                        </SettingsButton>
                    </div>
                )}
            </div>
        </>
    );
};


export default LedSettings;
